'use client';

import { c as _c } from "react/compiler-runtime";
import ROUTES from '@lib/constants/routes';
import cn from 'classnames';
import { debounce } from 'lodash';
import Link from 'next/link';
import { useState } from 'react';
import style from '../HeaderButtons.module.scss';
import { useHeaderColorScheme } from '../hooks/useIconWrapperStyle';
const DropDownFlats = t0 => {
  const $ = _c(13);
  const {
    headerColorScheme,
    onClick
  } = t0;
  const [toggleDropDown, setToggleDropDown] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = debounce(setToggleDropDown, 60);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const debouncedToggleDropDown = t1;
  const headerBtnStyle = useHeaderColorScheme(headerColorScheme);
  let t2;
  if ($[1] !== onClick || $[2] !== toggleDropDown) {
    t2 = () => {
      debouncedToggleDropDown(!toggleDropDown);
      onClick();
    };
    $[1] = onClick;
    $[2] = toggleDropDown;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleClick = t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => debouncedToggleDropDown(true);
    t4 = () => debouncedToggleDropDown(false);
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  const t5 = toggleDropDown ? style.active : null;
  let t6;
  if ($[6] !== headerBtnStyle || $[7] !== t5) {
    t6 = cn(headerBtnStyle, style.headerDropDownButton, t5);
    $[6] = headerBtnStyle;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span>Визуальный выбор</span>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== handleClick || $[11] !== t6) {
    t8 = <div onMouseOver={t3} onMouseLeave={t4} className={style.dropDownContainer} onFocus={_temp}><Link href={ROUTES.flats.visual.root}><button onClick={handleClick} className={t6}>{t7}</button></Link></div>;
    $[10] = handleClick;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
export default DropDownFlats;
function _temp() {
  return null;
}